import CommonTypes from './common.types';

export const errorHardReset = () => ({
  type: CommonTypes.ERROR_HARD_RESET,
});
